import * as React from 'react';
import styled from 'styled-components';
import { Headline, Text } from '@oneaudi/unified-web-components';
import { RenderMode } from '@oneaudi/render-mode-service';
import { useRenderMode } from '../../context/FeatureAppContext';

const ErrorMessage = styled(Text)`
  color: ${({ theme }) => theme.colors.error};
  display: block;
`;
const NotificationMessage = styled(Text)`
  color: ${({ theme }) => theme.colors.success};
  display: block;
`;

export interface WarningMessageProps {
  readonly anchors: number;
  readonly maxAnchors: number;
  readonly minAnchors: number;
}

export const WarningMessage = ({
  anchors,
  maxAnchors,
  minAnchors,
}: WarningMessageProps): JSX.Element | null => {
  if (useRenderMode() === RenderMode.DEFAULT) {
    return null;
  }

  function renderTooFew() {
    if (anchors >= minAnchors) {
      return null;
    }
    return (
      <Headline tag="h1" variant={{ type: 'headline', order: '3', weight: 'normal' }}>
        <ErrorMessage tag="span">
          Error: You configured {anchors} anchor{anchors !== 1 && 's'}. The Feature App will be
          activated after you placed at least {minAnchors} anchors with the separate “Anchor”
          Feature App on the page. It&apos;s recommended to use 4 to 6 anchors. Place this FA once
          only on the page ABOVE any Anchor FA.
        </ErrorMessage>
      </Headline>
    );
  }

  function renderTooMany() {
    if (anchors <= maxAnchors) {
      return null;
    }
    return (
      <Headline tag="h1" variant={{ type: 'headline', order: '3', weight: 'normal' }}>
        <ErrorMessage tag="span">
          Warning: You configured {anchors} anchors. Only up to {maxAnchors} are displayed. It’s
          recommended to use 4 to 6 anchors. Place once only on the page ABOVE any Anchor FA.
        </ErrorMessage>
      </Headline>
    );
  }

  function renderNotificaton() {
    return (
      <Headline tag="h1" variant={{ type: 'headline', order: '3', weight: 'normal' }}>
        <NotificationMessage tag="span">
          You configured {anchors} anchors. It’s recommended to use 4 to 6 anchors. Place once only
          on the page ABOVE any Anchor FA.
        </NotificationMessage>
      </Headline>
    );
  }

  return renderTooFew() || renderTooMany() || renderNotificaton();
};
